export enum LimitationDuration {
  Permanent = "permanent",
  Temporary = "temporary",
}
